import { Button } from '@mui/material';
import {
  ArrowsIn,
  ArrowsOut,
  Image,
  ListBullets,
  PaperPlaneTilt,
  TextAlignLeft,
  TextT,
} from '@phosphor-icons/react';
import { ITypeNode, useFormBuilder } from '../../Context/FormBuilderContext';
import { ActionTypes } from '../../Reducer';

// Types for toolbar items
interface ToolbarItem {
  type: ITypeNode;
  label: string;
  icon: React.ComponentType<any>;
  iconColor?: string;
}

const TOOLBAR_ITEMS: ToolbarItem[] = [
  { type: ITypeNode.TITLE, label: 'Title', icon: TextT, iconColor: '#3650DE' },
  {
    type: ITypeNode.SHORT_TEXT,
    label: 'Short Text',
    icon: TextAlignLeft,
    iconColor: '#3650DE',
  },
  { type: ITypeNode.IMAGE, label: 'Image', icon: Image, iconColor: '#3650DE' },
  {
    type: ITypeNode.LIST,
    label: 'List',
    icon: ListBullets,
    iconColor: '#3650DE',
  },
  {
    type: ITypeNode.INPUT,
    label: 'Input',
    icon: ArrowsIn,
    iconColor: '#3650DE',
  },
  {
    type: ITypeNode.OUTPUT,
    label: 'Output',
    icon: ArrowsOut,
    iconColor: '#3650DE',
  },
  {
    type: ITypeNode.SUBMIT,
    label: 'Submit',
    icon: PaperPlaneTilt,
    iconColor: '#3650DE',
  },
];

interface ToolbarButtonProps {
  item: ToolbarItem;
  onClick: (type: ITypeNode) => void;
}

function ToolbarButton({ item, onClick }: ToolbarButtonProps) {
  const { type, label, icon: Icon, iconColor } = item;

  return (
    <Button
      variant="text"
      onClick={() => onClick(type)}
      sx={{
        padding: '4px 16px',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '12px',
        fontWeight: '400',
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column' as const,
        alignItems: 'center',
        gap: '8px',
        color: '#98A2B3',
      }}
    >
      <Icon size={16} color={iconColor} />
      {label}
    </Button>
  );
}

export default function Toolbar() {
  const { dispatch } = useFormBuilder();

  const handleAddWidget = (type: ITypeNode) => {
    dispatch({
      type: ActionTypes.ADD_NODES,
      payload: { type },
    });
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        background: 'white',
        padding: '10px',
        borderRadius: '8px',
        width: '91px',
      }}
    >
      {TOOLBAR_ITEMS.map(item => (
        <ToolbarButton key={item.type} item={item} onClick={handleAddWidget} />
      ))}
    </div>
  );
}
